"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// src/data/Products_0.ts
const product_types_1 = require("../types/product.types");
const products = [
    // 974. Entrenament Grup Reduït Sant Adrià del Besòs - (1 hora)
    {
        id: 974,
        hidden: true,
        sku: "iopos.course.f2f.grup-reduit-sant-adria-4-1h",
        title: "Entrenament Grup Reduït Sant Adrià del Besòs - (1 hora)",
        name: "Entrenament Grup Reduït Sant Adrià del Besòs - (1 hora)",
        description: "Vols fer un salt de nivell? Agilitat + treball tècnic a mida en grups petits per treure el màxim rendiment a cada repetició.",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        enabled: true,
        stock: true,
        stock_message: "No disponible",
        price: 29.99,
        tax: 0.0,
        shipment: 0.0,
        images: ["/974/image1"],
        created_at: "2025-12-10 00:00:01",
        start_at: "2025-12-10 00:00:01",
        more_info: true,
        items: 1,
        can_be_sent: false,
        link: "/tienda/entrenaments/entrenament-grup-reduit-sant-adria-1-hora/",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        discount_not_applicable: true,
        calendly: {
            uuid: "da2b734b-f146-4cd7-9613-c37a103e1909",
            units: 1,
        },
    },
    // 975. Curs Presencial Caporals mossos 2026 (30 hores)
    {
        id: 975,
        sku: "iopos.course.f2f.curs-presencial-caporals-mossos-2026-30h",
        title: "Curs Presencial Caporals Mossos 2026 - (30 hores)",
        name: "Curs Presencial Caporals Mossos 2026 - (30 hores)",
        description: "Quatre dies intensius per saber exactament què estudiar, com estudiar-ho i arribar a l’examen de Caporal amb criteri, seguretat i avantatge real.",
        category: [product_types_1.Category.Mossos, product_types_1.Category.FaceToFace],
        enabled: false,
        stock: false,
        stock_message: "Aviat disponible",
        price: 119.99,
        tax: 0.0,
        offer: 149.99,
        offer_message: "Oferta especial les 20 primeres matrícules!",
        offer_text: "Oferta especial les 20 primeres matrícules!",
        shipment: 0.0,
        images: ["/975/image1"],
        created_at: "2025-12-12 00:00:01",
        start_at: "2025-12-12 00:00:01",
        more_info: true,
        items: 1,
        can_be_sent: false,
        link: "/tienda/cursos/curs-presencial-caporals-mossos-2026-30h/",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        discount_not_applicable: true,
        evolmind: {
            course_id: 910,
            group_id: [2740],
        },
    },
    // Simulacre de Físiques (CrossFit Lynx Sant Cugat, 28 Desembre 2025) (18-20 h)
    {
        id: 976,
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.simulacre-fisiques-sant-cugat-28d-2025-18-20",
        title: "Simulacre de Físiques (CrossFit Lynx Sant Cugat, 28 Desembre 2025) (18-20 h)",
        name: "Simulacre de Físiques (CrossFit Lynx Sant Cugat, 28 Desembre 2025) (18-20 h)",
        description: "No deixis escapar l'oportunitat de preparar-te amb el nostre Simulacre de Físiques 2025 al CrossFit Lynx!",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 24.99,
        shipment: 0.0,
        images: ["/670/image2"],
        banner: ["/670/image2"],
        link: "/tienda/cursos/simulacre-fisiques-sant-cugat-28-desembre-2025-18-20-h/",
        created_at: "2025-12-19 00:00:01",
        start_at: "2025-12-19 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        limit: 200,
        discount_not_applicable: true,
    },
    // Curs Presencial d'Oposicions a Policia Local 2026 (60 hores)
    {
        id: 977,
        category: [product_types_1.Category.PL, product_types_1.Category.FaceToFace],
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.curs-presencial-policia-local-2026-60h",
        title: "Curs Presencial Policia Local 2026 - (60 hores)",
        name: "Curs Presencial Policia Local 2026 - (60 hores)",
        description: "La preparació que et porta a conseguir la plaça de Policia Local.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        price: 299.99,
        shipment: 0.0,
        images: ["/977/image1"],
        banner: ["/977/image1"],
        link: "/tienda/cursos/curs-presencial-oposicions-policia-local-2026-60h/",
        created_at: "2025-12-31 00:00:01",
        start_at: "2025-12-31 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        evolmind: {
            course_id: 913,
            group_id: [2743],
        },
        availableUntilExam: true,
    },
    // Fase 2: Hospitalet - Preparació Entrevista Policial Mossos d'Esquadra 2026 (1:30 hores)
    {
        id: 978,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE2,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.fase2-preparacio-entrevista-policial-mossos-2027-1h30-hospitalet",
        title: "Fase 2: Hospitalet de Llobregat - Preparació Entrevista Policial Mossos 2027 (1:30 hores)",
        name: "Fase 2: Hospitalet de Llobregat - Preparació Entrevista Policial Mossos 2027 (1:30 hores)",
        description: "Sessió personalitzada per defensar el teu perfil amb seguretat i criteri a l'entrevista de Mossos d'Esquadra.",
        enabled: true,
        stock: false,
        stock_message: "Aviat disponible",
        // low_stock_message: "Últimes places disponibles!",
        special_buy: "/tienda/cursos/fase2-hospitalet-preparacio-entrevista-policial-mossos-2027-1h30/#reserva",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/978/image1"],
        banner: ["/978/image1"],
        link: "/tienda/cursos/fase2-hospitalet-preparacio-entrevista-policial-mossos-2027-1h30/",
        created_at: "2025-12-30 00:00:01",
        start_at: "2025-12-30 00:00:01",
        more_info: true,
        items: 1,
        calendly_schedule: [
            {
                id: 1,
                name: "Jordi",
                position: "Psicòleg col·legiat",
                description: "Rigor, criteri i domini dels barems d'avaluació.",
                location: "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-jordi/fase-2-preparacio-entrevista-mossos-2027-1-30-h-ho",
            },
            {
                id: 2,
                name: "Laia",
                position: "Agent en actiu i responsable de l’Àrea de Formació Mossos (iOpos)",
                description: "Acompanyament, millora personal i mentalitat de servei",
                location: "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-laia/fase-2-preparacio-entrevista-mossos-2027-1-30-h-ho",
            },
            {
                id: 3,
                name: "Paco",
                position: "Agent CME, ha format part d'unitats d'ordre públic, formador intern dels membres del cos.",
                description: "Preparació estratègica, exigència operativa i desenvolupament d’una mentalitat policial sòlida orientada al servei públic.",
                location: "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-paco/fase-2-preparacio-entrevista-mossos-2027-1-30-h-ho",
            },
            {
                id: 4,
                name: "Wassi",
                position: "Agent dels Mossos d’Esquadra i formadora especialitzada en tècniques avançades d’entrevista policial i anàlisi conductual.",
                description: "Precisió en l’anàlisi conductual, domini de l’entrevista per competències i enfocament pràctic per afrontar el tribunal amb seguretat i autenticitat.",
                location: "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-wassi/fase-2-preparacio-entrevista-mossos-2027-1-30-h-ho",
            },
        ],
    },
    // 979. Fase 2: Tarragona - Preparació Entrevista Policial Mossos d'Esquadra 2026 (1:30 hores)
    {
        id: 979,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE2,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.fase2-preparacio-entrevista-policial-mossos-2027-1h30-tarragona",
        title: "Fase 2: Tarragona - Preparació Entrevista Policial Mossos 2027 (1:30 hores)",
        name: "Fase 2: Tarragona - Preparació Entrevista Policial Mossos 2027 (1:30 hores)",
        description: "Sessió personalitzada per defensar el teu perfil amb seguretat i criteri a l'entrevista de Mossos d'Esquadra.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        // low_stock_message: "Últimes places disponibles!",
        special_buy: "/tienda/cursos/fase2-tarragona-preparacio-entrevista-policial-mossos-2027-1h30/#reserva",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/979/image1"],
        banner: ["/979/image1"],
        link: "/tienda/cursos/fase2-tarragona-preparacio-entrevista-policial-mossos-2027-1h30/",
        created_at: "2025-12-30 00:00:01",
        start_at: "2025-12-30 00:00:01",
        more_info: true,
        items: 1,
        calendly_schedule: [
            {
                id: 1,
                name: "Fran",
                position: "Sergent de Mossos d'Esquadra i Psicòleg",
                description: "Anàlisi profunda i transformació del candidat",
                location: "Tarragona Platja Coworking - i Casadevall, Carrer Josep Pla Casadevall, 3 - 5, bajos, 43007 Tarragona",
                link: "https://calendly.com/iopos-academia-fran/fase-2-preparacio-entrevista-mossos-2027-1-30-h-ta",
            },
        ],
    },
    // Fase 3: Hospitalet - Simulacre d'Entrevista Mossos d'Esquadra 2027 (1:00 hora)
    {
        id: 980,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE3,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.fase3-simulacre-entrevista-policial-mossos-2027-1h-hospitalet",
        title: "Fase 3: Hospitalet de Llobregat - Simulacre d'Entrevista Mossos d'Esquadra 2027 (1:00 h)",
        name: "Fase 3: Hospitalet de Llobregat - Simulacre d'Entrevista Mossos d'Esquadra 2027 (1:00 h)",
        description: "Posa a prova el teu perfil en una simulació real d'entrevista i corregeix errors abans que comptin de veritat.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        // low_stock_message: "Últimes places disponibles!",
        special_buy: "/tienda/cursos/fase3-hospitalet-simulacre-dentrevista-mossos-2027-1h/#reserva",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/980/image1"],
        banner: ["/980/image1"],
        link: "/tienda/cursos/fase3-hospitalet-simulacre-dentrevista-mossos-2027-1h/",
        created_at: "2025-12-30 00:00:01",
        start_at: "2025-12-30 00:00:01",
        more_info: true,
        items: 1,
        calendly_schedule: [
            {
                id: 1,
                name: "Jordi",
                position: "Psicòleg col·legiat",
                description: "Rigor, criteri i domini dels barems d'avaluació.",
                location: "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-jordi/fase-3-simulacre-entrevista-mossos-2026-1-h-ho",
            },
            /*{
                id: 2,
                name: "Laia",
                position:
                    "Agent en actiu i responsable de l’Àrea de Formació Mossos (iOpos)",
                description:
                    "Acompanyament, millora personal i mentalitat de servei",
                location:
                    "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-laia/fase-3-simulacre-entrevista-mossos-2026-1-h-ho",
            },
            {
                id: 3,
                name: "Paco",
                position:
                    "Agent CME, ha format part d'unitats d'ordre públic, formador intern dels membres del cos.",
                description:
                    "Preparació estratègica, exigència operativa i desenvolupament d’una mentalitat policial sòlida orientada al servei públic.",
                location:
                    "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-paco/fase-3-simulacre-entrevista-mossos-2026-1-h-ho",
            },
            {
                id: 4,
                name: "Wassi",
                position:
                    "Agent dels Mossos d’Esquadra i formadora especialitzada en tècniques avançades d’entrevista policial i anàlisi conductual.",
                description:
                    "Precisió en l’anàlisi conductual, domini de l’entrevista per competències i enfocament pràctic per afrontar el tribunal amb seguretat i autenticitat.",
                location:
                    "Carrer Martí Codolar, 18, 08902 L'Hospitalet de Llobregat, Barcelona",
                link: "https://calendly.com/iopos-academia-wassi/fase-3-simulacre-entrevista-mossos-2026-1-h-ho",
            },*/
        ],
    },
    // Fase 3: Tarragona - Simulacre d'Entrevista Mossos d'Esquadra 2027 (1:00 hora)
    {
        id: 981,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE3,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.fase3-simulacre-entrevista-policial-mossos-2027-1h-tarragona",
        title: "Fase 3: Tarragona - Simulacre d'Entrevista Mossos d'Esquadra 2027 (1:00 h)",
        name: "Fase 3: Tarragona - Simulacre d'Entrevista Mossos d'Esquadra 2027 (1:00 h)",
        description: "Posa a prova el teu perfil en una simulació real d'entrevista i corregeix errors abans que comptin de veritat.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        // low_stock_message: "Últimes places disponibles!",
        special_buy: "/tienda/cursos/fase3-tarragona-simulacre-dentrevista-mossos-2027-1h/#reserva",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 99.99,
        shipment: 0.0,
        images: ["/981/image1"],
        banner: ["/981/image1"],
        link: "/tienda/cursos/fase3-tarragona-simulacre-dentrevista-mossos-2027-1h/",
        created_at: "2025-12-30 00:00:01",
        start_at: "2025-12-30 00:00:01",
        more_info: true,
        items: 1,
        calendly_schedule: [
            {
                id: 1,
                name: "Fran",
                position: "Sergent de Mossos d'Esquadra i Psicòleg",
                description: "Anàlisi profunda i transformació del candidat",
                location: "Tarragona Platja Coworking - i Casadevall, Carrer Josep Pla Casadevall, 3 - 5, bajos, 43007 Tarragona",
                link: "https://calendly.com/iopos-academia-fran/fase-3-simulacre-entrevista-mossos-2027-1-h-ta",
            },
        ],
    },
    // Fase 2: Lleida - Preparació Entrevista Policial Mossos d'Esquadra 2027 (1:30 hores)
    {
        id: 982,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE2,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.fase2-preparacio-entrevista-policial-mossos-2027-1h30-lleida",
        title: "Fase 2: Lleida - Preparació Entrevista Policial Mossos 2027 (1:30 hores)",
        name: "Fase 2: Lleida - Preparació Entrevista Policial Mossos 2027 (1:30 hores)",
        description: "Sessió personalitzada per defensar el teu perfil amb seguretat i criteri a l'entrevista de Mossos d'Esquadra.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        // low_stock_message: "Últimes places disponibles!",
        special_buy: "/tienda/cursos/fase2-lleida-preparacio-entrevista-policial-mossos-2027-1h30/#reserva",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/982/image1"],
        banner: ["/982/image1"],
        link: "/tienda/cursos/fase2-lleida-preparacio-entrevista-policial-mossos-2027-1h30/",
        created_at: "2025-12-30 00:00:01",
        start_at: "2025-12-30 00:00:01",
        more_info: true,
        items: 1,
        calendly_schedule: [
            {
                id: 1,
                name: "Fran",
                position: "Sergent de Mossos d'Esquadra i Psicòleg",
                description: "Anàlisi profunda i transformació del candidat",
                location: "LoCowork Parc de l'Aigua - Av. Miquel Batllori, 81-83, 25001, Lleida",
                link: "https://calendly.com/iopos-academia-fran/fase-2-preparacio-entrevista-mossos-2027-1-30-h-lle",
            },
        ],
    },
    // Fase 3: Lleida - Simulacre d'Entrevista Mossos d'Esquadra 2027 (1:00 hora)
    {
        id: 984,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE3,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.fase3-simulacre-entrevista-policial-mossos-2027-1h-lleida",
        title: "Fase 3: Lleida - Simulacre d'Entrevista Mossos d'Esquadra 2027 (1:00 h)",
        name: "Fase 3: Lleida - Simulacre d'Entrevista Mossos d'Esquadra 2027 (1:00 h)",
        description: "Posa a prova el teu perfil en una simulació real d'entrevista i corregeix errors abans que comptin de veritat.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        // low_stock_message: "Últimes places disponibles!",
        special_buy: "/tienda/cursos/fase3-lleida-simulacre-dentrevista-mossos-2027-1h/#reserva",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/984/image1"],
        banner: ["/984/image1"],
        link: "/tienda/cursos/fase3-lleida-simulacre-dentrevista-mossos-2027-1h/",
        created_at: "2025-12-30 00:00:01",
        start_at: "2025-12-30 00:00:01",
        more_info: true,
        items: 1,
        calendly_schedule: [
            {
                id: 1,
                name: "Fran",
                position: "Sergent de Mossos d'Esquadra i Psicòleg",
                description: "Anàlisi profunda i transformació del candidat",
                location: "LoCowork Parc de l'Aigua - Av. Miquel Batllori, 81-83, 25001, Lleida",
                link: "https://calendly.com/iopos-academia-fran/fase-3-simulacre-entrevista-mossos-2027-1-00-h-lle",
            },
        ],
    },
    // Fase 2: Granollers - Preparació Entrevista Policial Mossos d'Esquadra 2027 (1:30 hores)
    {
        id: 986,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE2,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.fase2-preparacio-entrevista-policial-mossos-2027-1h30-granollers",
        title: "Fase 2: Granollers - Preparació Entrevista Policial Mossos 2027 (1:30 hores)",
        name: "Fase 2: Granollers - Preparació Entrevista Policial Mossos 2027 (1:30 hores)",
        description: "Sessió personalitzada per defensar el teu perfil amb seguretat i criteri a l'entrevista de Mossos d'Esquadra.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        // low_stock_message: "Últimes places disponibles!",
        special_buy: "/tienda/cursos/fase2-granollers-preparacio-entrevista-policial-mossos-2027-1h30/#reserva",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/986/image1"],
        banner: ["/986/image1"],
        link: "/tienda/cursos/fase2-granollers-preparacio-entrevista-policial-mossos-2027-1h30/",
        created_at: "2025-12-30 00:00:01",
        start_at: "2025-12-30 00:00:01",
        more_info: true,
        items: 1,
        calendly_schedule: [
            {
                id: 1,
                name: "Rubén",
                position: "Comandament del Cos de Mossos d'Esquadra",
                description: "Visió interna, realisme i enfocament de tribunal",
                location: "Carrer de les Travesseres, 43, 08401 Granollers, Barcelona",
                link: "https://calendly.com/iopos-academia-ruben/fase-2-preparacio-entrevista-mossos-2027-1-30-h-gr",
            },
        ],
    },
    // Fase 3: Granollers - Simulacre d'Entrevista Mossos d'Esquadra 2027 (1:00 hora)
    {
        id: 987,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE3,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.fase3-simulacre-entrevista-policial-mossos-2027-1h-granollers",
        title: "Fase 3: Granollers - Simulacre d'Entrevista Mossos d'Esquadra 2027 (1:00 h)",
        name: "Fase 3: Granollers - Simulacre d'Entrevista Mossos d'Esquadra 2027 (1:00 h)",
        description: "Posa a prova el teu perfil en una simulació real d'entrevista i corregeix errors abans que comptin de veritat.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        // low_stock_message: "Últimes places disponibles!",
        special_buy: "/tienda/cursos/fase3-granollers-simulacre-dentrevista-mossos-2027-1h/#reserva",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/987/image1"],
        banner: ["/987/image1"],
        link: "/tienda/cursos/fase3-granollers-simulacre-dentrevista-mossos-2027-1h/",
        created_at: "2025-12-30 00:00:01",
        start_at: "2025-12-30 00:00:01",
        more_info: true,
        items: 1,
        calendly_schedule: [
            {
                id: 1,
                name: "Rubén",
                position: "Comandament del Cos de Mossos d'Esquadra",
                description: "Visió interna, realisme i enfocament de tribunal",
                location: "Carrer de les Travesseres, 43, 08401 Granollers, Barcelona",
                link: "https://calendly.com/iopos-academia-ruben/fase-3-simulacre-entrevista-mossos-2027-1-h-gr",
            },
        ],
    },
    // Fase 2: Mataró - Preparació Entrevista Policial Mossos d'Esquadra 2027 (1:30 hores)
    {
        id: 988,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE2,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.fase2-preparacio-entrevista-policial-mossos-2027-1h30-mataro",
        title: "Fase 2: Mataró - Preparació Entrevista Policial Mossos 2027 (1:30 hores)",
        name: "Fase 2: Mataró - Preparació Entrevista Policial Mossos 2027 (1:30 hores)",
        description: "Sessió personalitzada per defensar el teu perfil amb seguretat i criteri a l'entrevista de Mossos d'Esquadra.",
        enabled: false,
        stock: false,
        stock_message: "Aviat disponible",
        // low_stock_message: "Últimes places disponibles!",
        special_buy: "/tienda/cursos/fase2-mataro-preparacio-entrevista-policial-mossos-2027-1h30/#reserva",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/988/image1"],
        banner: ["/988/image1"],
        link: "/tienda/cursos/fase2-mataro-preparacio-entrevista-policial-mossos-2027-1h30/",
        created_at: "2025-12-30 00:00:01",
        start_at: "2025-12-30 00:00:01",
        more_info: true,
        items: 1,
        calendly_schedule: [
            {
                id: 1,
                name: "Txema",
                position: " Agent en actiu i responsable de Psicotècnics i Tutorització (iOpos)",
                description: "Estratègia, entrenaments i resultats.",
                location: "ÀTIC Coworking Business Center, Carrer Balançó i Boter, 22, 08302 Mataró, Barcelona",
                link: "https://calendly.com/iopos-academia-jose-m/fase-2-preparacio-entrevista-mossos-2027-1-30-h-ma",
            },
        ],
    },
    // Fase 3: Mataró - Simulacre d'Entrevista Mossos d'Esquadra 2027 (1:00 hora)
    {
        id: 989,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE3,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.fase3-simulacre-entrevista-policial-mossos-2027-1h-mataro",
        title: "Fase 3: Mataró - Simulacre d'Entrevista Mossos d'Esquadra 2027 (1:00 h)",
        name: "Fase 3: Mataró - Simulacre d'Entrevista Mossos d'Esquadra 2027 (1:00 h)",
        description: "Posa a prova el teu perfil en una simulació real d'entrevista i corregeix errors abans que comptin de veritat.",
        enabled: false,
        stock: false,
        stock_message: "Aviat disponible",
        // low_stock_message: "Últimes places disponibles!",
        special_buy: "/tienda/cursos/fase3-mataro-simulacre-dentrevista-mossos-2027-1h/#reserva",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/989/image1"],
        banner: ["/989/image1"],
        link: "/tienda/cursos/fase3-mataro-simulacre-dentrevista-mossos-2027-1h/",
        created_at: "2025-12-30 00:00:01",
        start_at: "2025-12-30 00:00:01",
        more_info: true,
        items: 1,
        calendly_schedule: [
            {
                id: 1,
                name: "Txema",
                position: "Agent en actiu i responsable de Psicotècnics i Tutorització (iOpos)",
                description: "Estratègia, entrenaments i resultats.",
                location: "ÀTIC Coworking Business Center, Carrer Balançó i Boter, 22, 08302 Mataró, Barcelona",
                link: "https://calendly.com/iopos-academia-jose-m/fase-3-simulacre-entrevista-mossos-2027-1-h-ma",
            },
        ],
    },
    // 990. Fase 4: Granollers - Simulacre d'Entrevista Premium Mossos d'Esquadra 2026 (1:00 hora)
    {
        id: 990,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE4,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.fase4-simulacre-entrevista-premium-policial-mossos-2027-1h-granollers",
        title: "Fase 4: Granollers - Simulacre d'Entrevista Premium Mossos d'Esquadra 2027 (1:00 h)",
        name: "Fase 4: Granollers - Simulacre d'Entrevista Premium Mossos d'Esquadra 2027 (1:00 h)",
        description: "Una doble avaluació professional que et permet saber exactament com rendiries davant el tribunal real.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        // low_stock_message: "Últimes places disponibles!",
        special_buy: "/tienda/cursos/fase4-granollers-simulacre-dentrevista-premium-mossos-2027-1h/#reserva",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 189.99,
        shipment: 0.0,
        images: ["/990/image1"],
        banner: ["/990/image1"],
        link: "/tienda/cursos/fase4-granollers-simulacre-dentrevista-premium-mossos-2027-1h/",
        created_at: "2026-01-14 00:00:01",
        start_at: "2026-01-14 00:00:01",
        more_info: true,
        items: 1,
        calendly_schedule: [
            {
                id: 1,
                name: "Rubén i Jordi",
                position: "Comandament Mossos i Psicòleg col·legiat",
                description: "Visió interna, realisme i enfocament de tribunal - Rigor, criteri i domini dels barems d’avaluació.",
                location: "Carrer de les Travesseres, 43, 08401 Granollers, Barcelona",
                link: "https://calendly.com/d/cxfk-brg-j7g/fase-4-simulacre-entrevista-pre-mossos-2027-1-h-gr",
            },
        ],
    },
    // 991. Curso Derecho Administrativo
    {
        id: 991,
        tax: 0.0,
        sku: "iopos.course.online.curso-derecho-administrativo-2026",
        title: "Curs Dret Administratiu",
        name: "Curs Dret Administratiu",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_ADMINISTRATIVO_Y_REGIMEN_SANCIONADOR,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Formació especialitzada orientada a comprendre el funcionament de l’Administració pública i garantir una actuació policial ajustada al dret administratiu.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/991/image2"],
        banner: ["/991/image2"],
        link: "/tienda/cursos/formacion-policial/curso-derecho-administrativo-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [992, 993],
        multiple_languages: false,
        homologated: [
            {
                code: "RP20250071039",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
        hero: {
            firstTitle: "Curs Homologat de Dret Administratiu",
            secondTitle: "ISPC 2026",
            thirdTitle: "Formació **especialitzada** orientada a **comprendre** el **funcionament de l’Administració pública** i garantir una actuació policial ajustada al **dret administratiu**.",
            landscape: "/991/hero_h",
            portrait: "/991/hero_v",
        },
    },
    // 992. Curso Derecho Administrativo - ES
    {
        id: 992,
        tax: 0.0,
        sku: "iopos.course.online.curso-derecho-administrativo-2026-es",
        title: "Curso Derecho Administrativo",
        name: "Curso Derecho Administrativo",
        short: "1.) Derecho Administrativo",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_ADMINISTRATIVO_Y_REGIMEN_SANCIONADOR,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/991/image2"],
        banner: ["/991/image2"],
        link: "/tienda/cursos/formacion-policial/curso-derecho-administrativo-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 991,
        default_in_parent: true,
        evolmind: { course_id: 919, group_id: [2758] },
    },
    // 993. Curso Derecho Administrativo - CA
    {
        id: 993,
        tax: 0.0,
        sku: "iopos.course.online.curso-derecho-administrativo-2026-ca",
        title: "Curs Dret Administratiu",
        name: "Curs Dret Administratiu",
        short: "1.) Dret Administratiu",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_ADMINISTRATIVO_Y_REGIMEN_SANCIONADOR,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/991/image2"],
        banner: ["/991/image2"],
        link: "/tienda/cursos/formacion-policial/curso-derecho-administrativo-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 991,
        evolmind: { course_id: 916, group_id: [2755] },
    },
    // 994. Curso Ámbitos de Actuación en Materia de Policía Administrativa
    {
        id: 994,
        tax: 0.0,
        sku: "iopos.course.online.curso-ambitos-actuacion-policia-administrativa-2026",
        title: "Curs Àmbits d'Actuació en Matèria de Policia Administrativa",
        name: "Curs Àmbits d'Actuació en Matèria de Policia Administrativa",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_ADMINISTRATIVO_Y_REGIMEN_SANCIONADOR,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Formació especialitzada orientada a identificar i aplicar els principals àmbits d’actuació de la policia administrativa amb seguretat jurídica i criteri professional.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/994/image2"],
        banner: ["/994/image2"],
        link: "/tienda/cursos/formacion-policial/curso-ambitos-actuacion-policia-administrativa-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [995, 996],
        multiple_languages: false,
        homologated: [
            {
                code: "RP20250071041",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
        hero: {
            firstTitle: "Curs Homologat d'Àmbits d'Actuació en Matèria de Policia Administrativa",
            secondTitle: "ISPC 2026",
            thirdTitle: "Formació **especialitzada** orientada a **identificar** i **aplicar** els principals **àmbits d’actuació** de la **policia administrativa** amb **seguretat jurídica** i **criteri professional**.",
            landscape: "/994/hero_h",
            portrait: "/994/hero_v",
        },
    },
    // 995. Curso Ámbitos de Actuación en Materia de Policía Administrativa - ES
    {
        id: 995,
        tax: 0.0,
        sku: "iopos.course.online.curso-ambitos-actuacion-policia-administrativa-2026-es",
        title: "Curso Ámbitos de Actuación en Materia de Policía Administrativa",
        name: "Curso Ámbitos de Actuación en Materia de Policía Administrativa",
        short: "1.) Ámbitos de Actuación en Materia de Policía Administrativa",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_ADMINISTRATIVO_Y_REGIMEN_SANCIONADOR,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible y actualizado en breve.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/994/image2"],
        banner: ["/994/image2"],
        link: "/tienda/cursos/formacion-policial/curso-ambitos-actuacion-policia-administrativa-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 994,
        default_in_parent: true,
        evolmind: { course_id: 922, group_id: [2761] },
    },
    // 996. Curso Ámbitos de Actuación en Materia de Policía Administrativa - CA
    {
        id: 996,
        tax: 0.0,
        sku: "iopos.course.online.curso-ambitos-actuacion-policia-administrativa-2026-ca",
        title: "Curs Àmbits d'Actuació en Matèria de Policia Administrativa",
        name: "Curs Àmbits d'Actuació en Matèria de Policia Administrativa",
        short: "1.) Àmbits d'Actuació en Matèria de Policia Administrativa",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_ADMINISTRATIVO_Y_REGIMEN_SANCIONADOR,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/994/image2"],
        banner: ["/994/image2"],
        link: "/tienda/cursos/formacion-policial/curso-ambitos-actuacion-policia-administrativa-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 994,
        evolmind: { course_id: 925, group_id: [2764] },
    },
    // 997. Intervención Policial en Procesos y Delitos Electorales
    {
        id: 997,
        tax: 0.0,
        sku: "iopos.course.online.curso-intervencion-policial-procesos-delitos-electorales-2026",
        title: "Curs Intervenció Policial en Processos i Delictes Electorals",
        name: "Curs Intervenció Policial en Processos i Delictes Electorals",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.POLICIA_JUDICIAL_E_INVESTIGACION,
        ],
        description: "Formació especialitzada orientada a garantir la neutralitat institucional, la seguretat jurídica i la correcta actuació policial durant els processos electorals.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/997/image1"],
        banner: ["/997/image1"],
        link: "/tienda/cursos/formacion-policial/curso-intervencion-policial-procesos-delitos-electorales-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [998, 999],
        multiple_languages: false,
    },
    // 998. Intervención Policial en Procesos y Delitos Electorales - ES
    {
        id: 998,
        tax: 0.0,
        sku: "iopos.course.online.curso-intervencion-policial-procesos-delitos-electorales-2026-es",
        title: "Curso Intervención Policial en Procesos y Delitos Electorales",
        name: "Curso Intervención Policial en Procesos y Delitos Electorales",
        short: "1.) Intervención Policial en Procesos y Delitos Electorales",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.POLICIA_JUDICIAL_E_INVESTIGACION,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible y actualizado en breve.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/997/image1"],
        banner: ["/997/image1"],
        link: "/tienda/cursos/formacion-policial/curso-intervencion-policial-procesos-delitos-electorales-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 997,
        default_in_parent: true,
        evolmind: { course_id: 937, group_id: [2776] },
    },
    // 999. Intervención Policial en Procesos y Delitos Electorales - CA
    {
        id: 999,
        tax: 0.0,
        sku: "iopos.course.online.curso-intervencion-policial-procesos-delitos-electorales-2026-ca",
        title: "Curs Intervenció Policial en Processos i Delictes Electorals",
        name: "Curs Intervenció Policial en Processos i Delictes Electorals",
        short: "1.) Intervenció Policial en Processos i Delictes Electorals",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.POLICIA_JUDICIAL_E_INVESTIGACION,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/997/image1"],
        banner: ["/997/image1"],
        link: "/tienda/cursos/formacion-policial/curso-intervencion-policial-procesos-delitos-electorales-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 997,
        default_in_parent: true,
        evolmind: { course_id: 934, group_id: [2773] },
    },
    // 1000. Curso Psicología del Testimonio
    {
        id: 1000,
        tax: 0.0,
        sku: "iopos.course.online.curso-psicologia-del-testimonio-2026",
        title: "Curs Psicologia del Testimoni",
        name: "Curs Psicologia del Testimoni",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.POLICIA_JUDICIAL_E_INVESTIGACION,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Formació especialitzada orientada a obtenir, analitzar i valorar testimonis amb criteris científics, operatius i legals per millorar la fiabilitat de la prova testifical.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1000/image2"],
        banner: ["/1000/image2"],
        link: "/tienda/cursos/formacion-policial/curso-psicologia-del-testimonio-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1001, 1002],
        multiple_languages: false,
        homologated: [
            {
                code: "RP20250070979",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
        hero: {
            firstTitle: "Curs Homologat de Psicologia del Testimoni",
            secondTitle: "ISPC 2026",
            thirdTitle: "Formació **especialitzada** orientada a **obtenir**, **analitzar** i **valorar** testimonis amb criteris **científics**, **operatius** i **legals** per millorar la fiabilitat de la prova testifical.",
            landscape: "/1000/hero_h",
            portrait: "/1000/hero_v",
        },
    },
    // 1001. Curso Psicología del Testimonio - ES
    {
        id: 1001,
        tax: 0.0,
        sku: "iopos.course.online.curso-psicologia-del-testimonio-2026-es",
        title: "Curso Psicología del Testimonio",
        name: "Curso Psicología del Testimonio",
        short: "1.) Psicología del Testimonio",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.POLICIA_JUDICIAL_E_INVESTIGACION,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible y actualizado en breve.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1000/image1"],
        banner: ["/1000/image1"],
        link: "/tienda/cursos/formacion-policial/curso-psicologia-del-testimonio-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1000,
        default_in_parent: true,
        evolmind: { course_id: 943, group_id: [2782] },
    },
    // 1002. Curso Psicología del Testimonio - CA
    {
        id: 1002,
        tax: 0.0,
        sku: "iopos.course.online.curso-psicologia-del-testimonio-2026-ca",
        title: "Curs Psicologia del Testimoni",
        name: "Curs Psicologia del Testimoni",
        short: "1.) Psicologia del Testimoni",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.POLICIA_JUDICIAL_E_INVESTIGACION,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1000/image1"],
        banner: ["/1000/image1"],
        link: "/tienda/cursos/formacion-policial/curso-psicologia-del-testimonio-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1000,
        default_in_parent: true,
        evolmind: { course_id: 940, group_id: [2779] },
    },
    // 1003. Curso Accidente de Tráfico. Avanzado.
    {
        id: 1003,
        tax: 0.0,
        sku: "iopos.course.online.curso-accidente-de-trafico-avanzado-2026",
        title: "Curs Accident de Trànsit (Avançat)",
        name: "Curs Accident de Trànsit. (Avançat)",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "Formació avançada orientada a millorar la intervenció policial en accidents de trànsit complexos, amb víctimes i escenaris d’alta exigència tècnica i jurídica.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1003/image4"],
        banner: ["/1003/image4"],
        link: "/tienda/cursos/formacion-policial/curso-accidente-de-trafico-avanzado-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1004, 1005],
        multiple_languages: false,
    },
    // 1004. Curso Accidente de Tráfico. Avanzado. - ES
    {
        id: 1004,
        tax: 0.0,
        sku: "iopos.course.online.curso-accidente-de-trafico-avanzado-2026-es",
        title: "Curso Accidente de Tráfico. Avanzado.",
        name: "Curso Accidente de Tráfico. Avanzado.",
        short: "1.) Accidente de Tráfico. Avanzado.",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible y actualizado en breve.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1003/image4"],
        banner: ["/1003/image4"],
        link: "/tienda/cursos/formacion-policial/curso-accidente-de-trafico-avanzado-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1003,
        default_in_parent: true,
        evolmind: { course_id: 949, group_id: [2788] },
    },
    // 1005. Curso Accidente de Tráfico. Avanzado. - CA
    {
        id: 1005,
        tax: 0.0,
        sku: "iopos.course.online.curso-accidente-de-trafico-avanzado-2026-ca",
        title: "Curs Accident de Trànsit. Avançat.",
        name: "Curs Accident de Trànsit. Avançat.",
        short: "1.) Accident de Trànsit. Avançat.",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1003/image4"],
        banner: ["/1003/image4"],
        link: "/tienda/cursos/formacion-policial/curso-accidente-de-trafico-avanzado-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1003,
        default_in_parent: true,
        evolmind: { course_id: 946, group_id: [2785] },
    },
    // 1006. Curso Mercancías Peligrosas en el Ámbito de la Circulacion. ADR.
    {
        id: 1006,
        tax: 0.0,
        sku: "iopos.course.online.curso-mercancias-peligrosas-ambito-circulacion-adr-2026",
        title: "Curs Mercaderies Perilloses en l'Àmbit de la Circulació (ADR)",
        name: "Curs Mercaderies Perilloses en l'Àmbit de la Circulació (ADR)",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "Formació especialitzada orientada a identificar, controlar i intervenir amb seguretat davant el transport de mercaderies perilloses, garantint la protecció de les persones i del medi ambient.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1006/image1"],
        banner: ["/1006/image1"],
        link: "/tienda/cursos/formacion-policial/curso-mercancias-peligrosas-ambito-circulacion-adr-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1007, 1008],
        multiple_languages: false,
    },
    // 1007. Curso Mercancías Peligrosas en el Ámbito de la Circulacion. ADR. - ES
    {
        id: 1007,
        tax: 0.0,
        sku: "iopos.course.online.curso-mercancias-peligrosas-ambito-circulacion-adr-2026-es",
        title: "Curso Mercancías Peligrosas en el Ámbito de la Circulacion. ADR.",
        name: "Curso Mercancías Peligrosas en el Ámbito de la Circulacion. ADR.",
        short: "1.) Mercancías Peligrosas en el Ámbito de la Circulacion. ADR.",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible y actualizado en breve.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1007/image1"],
        banner: ["/1007/image1"],
        link: "/tienda/cursos/formacion-policial/curso-mercancias-peligrosas-ambito-circulacion-adr-es/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1006,
        default_in_parent: true,
        evolmind: { course_id: 955, group_id: [2794] },
    },
    // 1008. Curso Mercancías Peligrosas en el Ámbito de la Circulacion. ADR. - CA
    {
        id: 1008,
        tax: 0.0,
        sku: "iopos.course.online.curso-mercancias-peligrosas-ambito-circulacion-adr-2026-ca",
        title: "Curs Mercaderies Perilloses en l'Àmbit de la Circulació. ADR.",
        name: "Curs Mercaderies Perilloses en l'Àmbit de la Circulació. ADR.",
        short: "1.) Mercaderies Perilloses en l'Àmbit de la Circulació. ADR.",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1006/image1"],
        banner: ["/1006/image1"],
        link: "/tienda/cursos/formacion-policial/curso-mercancias-peligrosas-ambito-circulacion-adr-2026-ca/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1003,
        default_in_parent: true,
        evolmind: { course_id: 952, group_id: [2791] },
    },
    // 1009. Curso Permisos y Licencias de Conducción. Normativa Penal y Administrativa.
    {
        id: 1009,
        tax: 0.0,
        sku: "iopos.course.online.curso-permisos-licencias-conduccion-normativa-penal-administrativa-2026",
        title: "Curs Permisos i Llicències de Conducció. Normativa Penal i Administrativa.",
        name: "Curs Permisos i Llicències de Conducció. Normativa Penal i Administrativa.",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "Formació especialitzada orientada a garantir una correcta aplicació normativa en matèria de permisos i llicències de conducció, amb criteri jurídic, seguretat operativa i rigor en la intervenció policial.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1009/image1"],
        banner: ["/1009/image1"],
        link: "/tienda/cursos/formacion-policial/curso-permisos-licencias-conduccion-normativa-penal-administrativa-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1010, 1011],
        multiple_languages: false,
    },
    // 1010. Curso Permisos y Licencias de Conducción. Normativa Penal y Administrativa - ES
    {
        id: 1010,
        tax: 0.0,
        sku: "iopos.course.online.curso-permisos-licencias-conduccion-normativa-penal-administrativa-2026-es",
        title: "Curso Permisos y Licencias de Conducción. Normativa Penal y Administrativa.",
        name: "Curso Permisos y Licencias de Conducción. Normativa Penal y Administrativa.",
        short: "1.) Permisos y Licencias de Conducción. Normativa Penal y Administrativa.",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible y actualizado en breve.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1010/image1"],
        banner: ["/1010/image1"],
        link: "/tienda/cursos/formacion-policial/curso-permisos-licencias-conduccion-normativa-penal-administrativa-2026/",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1009,
        default_in_parent: true,
        evolmind: { course_id: 961, group_id: [2800] },
    },
    // 1011. Curso Permisos y Licencias de Conducción. Normativa Penal y Administrativa - CA
    {
        id: 1011,
        tax: 0.0,
        sku: "iopos.course.online.curso-permisos-licencias-conduccion-normativa-penal-administrativa-2026-ca",
        title: "Curs Permisos i Llicències de Conducció. Normativa Penal i Administrativa.",
        name: "Curs Permisos i Llicències de Conducció. Normativa Penal i Administrativa.",
        short: "1.) Permisos i Llicències de Conducció. Normativa Penal i Administrativa.",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1009/image1"],
        banner: ["/1009/image1"],
        link: "/tienda/cursos/formacion-policial/curso-permisos-licencias-conduccion-normativa-penal-administrativa-2026",
        created_at: "2026-01-13 00:00:01",
        start_at: "2026-01-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 1009,
        default_in_parent: true,
        evolmind: { course_id: 958, group_id: [2797] },
    },
    // 1013. 5ª Sessió Nivell 2 Espai Bulevard (5h - 14/03/2026)
    {
        id: 1013,
        tax: 0.0,
        sku: "iopos.course.f2f.sessio-espai-bulevard-5hores-14-mar-2026",
        title: "Sessió Espai Bulevard (5h - 14/03/2026)",
        name: "Sessió Espai Bulevard (5h - 14/03/2026)",
        description: "Practica i aplica en 5 hores allò que marcarà la diferència a l'ISPC.",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 49.99,
        images: ["/940/image1"],
        banner: ["/940/image1"],
        link: "/tienda/cursos/sessio-espai-bulevard-5hores-14-mar-2026/",
        more_info: true,
        can_be_sent: false,
        items: 1,
        created_at: "2026-01-15 00:00:10",
        start_at: "2026-01-15 00:00:10",
        updated_at: "2026-01-15 00:00:10",
        notify_emails: ["tonicalvo@iopos.academy"],
        evolmind: { course_id: 894, group_id: [3109] },
    },
    // 1014. Curso Oficina de Apoyo Curso Básico
    {
        id: 1014,
        tax: 0.21,
        sku: "iopos.course.online.curso-oficina-de-apoyo-curso-basico-2026",
        title: "Curs Oficina de Suport Curs Bàsic",
        name: "Curs Oficina de Suport Curs Bàsic",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "Formació especialitzada orientada a desenvolupar amb criteri tècnic, rigor normatiu i eficàcia operativa les funcions pròpies d’una Oficina de Suport dins el CME",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1014/image2"],
        banner: ["/1014/image2"],
        link: "/tienda/cursos/formacion-policial/curso-oficina-de-apoyo-curso-basico-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1015, 1016],
        multiple_languages: false,
    },
    // 1015. Curso Oficina de Apoyo Curso Básico - ES
    {
        id: 1015,
        tax: 0.21,
        sku: "iopos.course.online.curso-oficina-de-apoyo-curso-basico-2026-es",
        title: "Curso Oficina de Apoyo Curso Básico",
        name: "Curso Oficina de Apoyo Curso Básico",
        short: "1.) Oficina de Apoyo Curso Básico",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1014/image2"],
        banner: ["/1014/image2"],
        link: "/tienda/cursos/formacion-policial/curso-oficina-de-apoyo-curso-basico-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1014,
        evolmind: { course_id: 967, group_id: [2806] },
    },
    // 1016. Curso Oficina de Apoyo Curso Básico - CA
    {
        id: 1016,
        tax: 0.21,
        sku: "iopos.course.online.curso-oficina-de-apoyo-curso-basico-2026-ca",
        title: "Curs Oficina de Suport Curs Bàsic",
        name: "Curs Oficina de Suport Curs Bàsic",
        short: "1.) Oficina de Suport Curs Bàsic",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1014/image2"],
        banner: ["/1014/image2"],
        link: "/tienda/cursos/formacion-policial/curso-oficina-de-apoyo-curso-basico-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1014,
        evolmind: { course_id: 970, group_id: [2809] },
    },
    // 1017. Curso Derecho Penal y Procesal
    {
        id: 1017,
        tax: 0.0,
        sku: "iopos.course.online.curso-derecho-penal-y-procesal-2026",
        title: "Curs Dret Penal i Processal",
        name: "Curs Dret Penal i Processal",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Formació jurídica especialitzada orientada a consolidar els fonaments del dret penal i processal penal, garantint una actuació policial rigorosa i jurídicament segura.",
        enabled: false,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1017/image2"],
        banner: ["/1017/image2"],
        link: "/tienda/cursos/formacion-policial/curso-derecho-penal-y-procesal-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1018, 1019],
        multiple_languages: false,
        homologated: [
            {
                code: "RP20250071042",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
        hero: {
            firstTitle: "Curs Homologat de Dret Penal i Processal",
            secondTitle: "ISPC 2026",
            thirdTitle: "Formació **especialitzada** orientada a **consolidar** els **fonaments** del **dret penal** i **processal penal**, garantint una actuació policial **rigorosa** i **jurídicament segura**.",
            landscape: "/1017/hero_h",
            portrait: "/1017/hero_v",
        },
    },
    // 1018. Curso Derecho Penal y Procesal - ES
    {
        id: 1018,
        tax: 0.0,
        sku: "iopos.course.online.curso-derecho-penal-y-procesal-2026-es",
        title: "Curso Derecho Penal y Procesal",
        name: "Curso Derecho Penal y Procesal",
        short: "1.) Derecho Penal y Procesal",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1017/image2"],
        banner: ["/1017/image2"],
        link: "/tienda/cursos/formacion-policial/curso-derecho-penal-y-procesal-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1017,
        // multiple_languages: false,
        evolmind: { course_id: 976, group_id: [2815] },
    },
    // 1019. Curso Derecho Penal y Procesal - CA
    {
        id: 1019,
        tax: 0.0,
        sku: "iopos.course.online.curso-derecho-penal-y-procesal-2026-ca",
        title: "Curs Dret Penal i Processal",
        name: "Curs Dret Penal i Processal",
        short: "1.) Dret Penal i Processal",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1017/image2"],
        banner: ["/1017/image2"],
        link: "/tienda/cursos/formacion-policial/curso-derecho-penal-y-procesal-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1017,
        // multiple_languages: false,
        evolmind: { course_id: 973, group_id: [2812] },
    },
    // 1020. Curso Delitos Contra los Trabajores y los Extrangeros, contra la Hacienda Pública y la Seguridad Social
    {
        id: 1020,
        tax: 0.21,
        sku: "iopos.course.online.curso-delitos-contra-trabjadores-hacienda-seg-social-2026",
        title: "Curs Delictes Contra els Treballadors i els Estrangers, contra la Hisenda Pública i la Seguretat Social",
        name: "Curs Delictes Contra els Treballadors i els Estrangers, contra la Hisenda Pública i la Seguretat Social",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "Formació jurídica especialitzada orientada a identificar, qualificar i intervenir amb seguretat jurídica davant delictes contra els treballadors, els estrangers, la Hisenda Pública i la Seguretat Social.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1020/image2"],
        banner: ["/1020/image2"],
        link: "/tienda/cursos/formacion-policial/curso-delitos-contra-trabajadores-extrangeros-contra-hacienda-publica-seguridad-social-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1021, 1022],
        multiple_languages: false,
    },
    // 1021. Curso Delitos Contra los Trabajores y los Extrangeros, contra la Hacienda Pública y la Seguridad Social - ES
    {
        id: 1021,
        tax: 0.21,
        sku: "iopos.course.online.curso-delitos-contra-trabajadores-hacienda-seg-social-2026-es",
        title: "Curso Delitos Contra los Trabajores y los Extrangeros, contra la Hacienda Pública y la Seguridad Social",
        name: "Curso Delitos Contra los Trabajores y los Extrangeros, contra la Hacienda Pública y la Seguridad Social",
        short: "1.) Delitos Contra los Trabajores y los Extrangeros, contra la Hacienda Pública y la Seguridad Social",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1020/image2"],
        banner: ["/1020/image2"],
        link: "/tienda/cursos/formacion-policial/curso-delitos-contra-trabajadores-extrangeros-contra-hacienda-publica-seguridad-social-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1020,
        evolmind: { course_id: 979, group_id: [2818] },
    },
    // 1022. Curso Delitos Contra los Trabajores y los Extrangeros, contra la Hacienda Pública y la Seguridad Social - CA
    {
        id: 1022,
        tax: 0.21,
        sku: "iopos.course.online.curso-delitos-contra-trabajadores-hacienda-seg-social-2026-ca",
        title: "Curs Delictes Contra els Treballadors i els Estrangers, contra la Hisenda Pública i la Seguretat Social",
        name: "Curs Delictes Contra els Treballadors i els Estrangers, contra la Hisenda Pública i la Seguretat Social",
        short: "1.) Delictes Contra els Treballadors i els Estrangers, contra la Hisenda Pública i la Seguretat Social",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "Formació jurídica especialitzada orientada a identificar, qualificar i intervenir amb seguretat jurídica davant delictes contra els treballadors, els estrangers, la Hisenda Pública i la Seguretat Social.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1020/image2"],
        banner: ["/1020/image2"],
        link: "/tienda/cursos/formacion-policial/curso-delitos-contra-trabajadores-extrangeros-contra-hacienda-publica-seguridad-social-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1020,
        evolmind: { course_id: 982, group_id: [2821] },
    },
    // 1023. Curso Delitros con el Patrimonio y el Orden Socieconómico
    {
        id: 1023,
        tax: 0.21,
        sku: "iopos.course.online.curso-delitos-contra-patrimonio-orden-socieconomico-2026",
        title: "Curs Delictes contra el Patrimoni i l'Ordre Socioeconòmic",
        name: "Curs Delictes contra el Patrimoni i l'Ordre Socioeconòmic",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "Formació penal especialitzada orientada a identificar, qualificar i intervenir amb criteri jurídic davant els delictes contra el patrimoni i l’ordre socioeconòmic.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        shipment: 0.0,
        images: ["/1023/image2"],
        banner: ["/1023/image2"],
        link: "/tienda/cursos/formacion-policial/curso-delitos-contra-patrimonio-orden-socieconomico-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1024, 1025],
        multiple_languages: false,
    },
    // 1024. Curso Delitos contra el Patrimonio y el Orden Socieconómico - ES
    {
        id: 1024,
        tax: 0.21,
        sku: "iopos.course.online.curso-delitos-contra-patrimonio-orden-socieconomico-2026-es",
        title: "Curso Delitos contra el Patrimonio y el Orden Socieconómico",
        name: "Curso Delitos contra el Patrimonio y el Orden Socieconómico",
        short: "1.) Delitos contra el Patrimonio y el Orden Socieconómico",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        shipment: 0.0,
        images: ["/1023/image2"],
        banner: ["/1023/image2"],
        link: "/tienda/cursos/formacion-policial/curso-delitos-contra-patrimonio-orden-socieconomico-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1023,
        evolmind: { course_id: 985, group_id: [2824] },
    },
    // 1025. Curso Delitos contra el Patrimonio y el Orden Socioeconómico - CA
    {
        id: 1025,
        tax: 0.21,
        sku: "iopos.course.online.curso-delitos-contra-patrimonio-orden-socieconomico-2026-ca",
        title: "Curs Delictes contra el Patrimoni i l'Ordre Socioeconòmic",
        name: "Curs Delictes contra el Patrimoni i l'Ordre Socioeconòmic",
        short: "1.) Delictes contra el Patrimoni i l'Ordre Socioeconòmic",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        shipment: 0.0,
        images: ["/1023/image2"],
        banner: ["/1023/image2"],
        link: "/tienda/cursos/formacion-policial/curso-delitos-contra-patrimonio-orden-socieconomico-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1023,
        evolmind: { course_id: 988, group_id: [2827] },
    },
    // 1026. Curso Código Penal. Parte Específica. Delitos contra la Salud Pública
    {
        id: 1026,
        tax: 0.21,
        sku: "iopos.course.online.curso-codigo-penal-parte-especifica-delitos-contra-la-salud-publica-2026",
        title: "Curs Codi Penal. Part Específica. Delictes contra la Salut Pública.",
        name: "Curs Codi Penal. Part Específica. Delictes contra la Salut Pública.",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: " Formació penal especialitzada orientada a comprendre, aplicar i interpretar els delictes contra la salut pública des d’una perspectiva jurídica, operativa i jurisprudencial.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1026/image2"],
        banner: ["/1026/image2"],
        link: "/tienda/cursos/formacion-policial/curso-codigo-penal-parte-especifica-delitos-contra-la-salud-publica-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1027, 1028],
        multiple_languages: false,
    },
    // 1027. Curso Código Penal. Parte Específica. Delitos contra la Salud Pública - ES
    {
        id: 1027,
        tax: 0.21,
        sku: "iopos.course.online.curso-codigo-penal-parte-especifica-delitos-contra-la-salud-publica-2026-es",
        title: "Curso Código Penal. Parte Específica. Delitos contra la Salud Pública.",
        name: "Curso Código Penal. Parte Específica. Delitos contra la Salud Pública.",
        short: "1.) Código Penal. Parte Específica. Delitos contra la Salud Pública.",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1026/image2"],
        banner: ["/1026/image2"],
        link: "/tienda/cursos/formacion-policial/curso-codigo-penal-parte-especifica-delitos-contra-la-salud-publica-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1026,
        evolmind: { course_id: 994, group_id: [2833] },
    },
    // 1028. Curso Código Penal. Parte Específica. Delitos contra la Salud Pública - CA
    {
        id: 1028,
        tax: 0.21,
        sku: "iopos.course.online.curso-codigo-penal-parte-especifica-delitos-contra-la-salud-publica-2026-ca",
        title: "Curs Codi Penal. Part Específica. Delictes contra la Salut Pública.",
        name: "Curs Codi Penal. Part Específica. Delictes contra la Salut Pública.",
        short: "1.) Delictes contra la Salut Pública",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1026/image2"],
        banner: ["/1026/image2"],
        link: "/tienda/cursos/formacion-policial/curso-codigo-penal-parte-especifica-delitos-contra-la-salud-publica-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1026,
        evolmind: { course_id: 991, group_id: [2830] },
    },
];
exports.default = products;
